<template>
  <v-card title="考勤一览">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="kqyf"
                  placeholder="考勤月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <vxe-select v-model="khbh" size="mini" placeholder="请选择客户" :options="khbh_options" clearable></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
import axios from "axios";
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      khbh_options: [],
      khbh:"",
      kqyf:dateFormat("YYYYmm", new Date()),
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "khmc",
            title: "客户名称",
            align: "center",
          },
          {
            field: "sl",
            title: "应考勤",
            headerAlign:"center",
            align: "right",
          },
          {
            field: "ykq",
            title: "已考勤",
            headerAlign:"center",
            align: "right",
            slots: {
              default: ({ row, column }) => {
                let ykq;
                if (row.ykq == "" || row.ykq == null) {
                  ykq = "0"
                } else {
                  ykq = row.ykq
                }
                return [
                  <span>{ykq}</span>
                ];
              }
            }
          },
          {
            title: "未考勤",
            headerAlign:"center",
            align: "right",
            slots: {
              default: ({ row, column }) => {
                let ykq;
                if (row.ykq == "" || row.ykq == null) {
                  ykq = "0"
                } else {
                  ykq = row.ykq
                }
                let wkq =  parseInt(row.sl)- parseInt(ykq)
                return [
                  <span>{wkq}</span>
                ];
              }
            }
          },
          {
            title: "考勤率",
            headerAlign:"center",
            align: "right",
            slots: {
              default: ({ row, column }) => {
                let ykq;
                if (row.ykq == "" || row.ykq == null) {
                  ykq = "0"
                } else {
                  ykq = row.ykq
                }
                let kql =  parseInt(ykq)/parseInt(row.sl)
                return [
                  <span>{toPercent(kql)}</span>
                ];
              }
            }
          }
        ],
      },
    };
  },
  created() {
    this.init_khbh();
    this.findList();
  },
  methods: {
    findList() {
      if(this.kqyf == ""){
        this.$message["error"]("请选择考勤月份！");
        return;
      }
      axios
        .get(
          "api/system/kqyr/get-kqyr-list?kqyf=" +
            this.kqyf+
            "&khbh="+
            this.khbh
        )
        .then((res) => {
          this.tableData = res.data.data;
        });
    },
    init_khbh: function () {
      axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khjc };
        });
      });
    },
  },
};
function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
function toPercent(point){
            if (point==0) {
                return 0;
            }
            var str=Number(point*100).toFixed();
            str+="%";
            return str;
        }
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/kqgl/kqyr.vue